module.exports = __webpack_public_path__ + "static/media/README.734e7ac8.md";